import {
    BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid,
    Tooltip, ResponsiveContainer,
} from 'recharts';

export const Charts = ({
    data,
}: {
    data: any,
}) => {
    return (
        <div className="mt-3">
            <ResponsiveContainer width="100%" height={260}>
                <BarChart
                    data={data}
                    margin={{
                        top: 12, right: 24, left: -12, bottom: 0,
                    }}
                >
                    <defs>
                        <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#2a99d7" stopOpacity={0.7} />  
                            <stop offset="100%" stopColor="#1c8ec9" stopOpacity={0.7} />
                        </linearGradient>
                    </defs>

                    <XAxis
                        dataKey="name"
                        stroke="#999"
                        tick={{ fontSize: 14 }}
                    />
                    <YAxis tick={{ fontSize: 11, fill: '#999' }} stroke="#fff" />
                    
                    <CartesianGrid vertical={false} strokeDasharray="2" />

                    <Tooltip
                        cursor={{ fill: '#f7f7f7' }}
                        content={({ active, payload, label }) => {
                            if (active && label && payload) {
                                return (
                                    <div className="chart-tooltip bg-white bg-opacity-80 p-4 rounded text-black">
                                        <div className="date text-lg font-bold">Monthly Usage</div>
                                        <div className="date text-sm text-[#666]">{payload[0].payload.label}</div>
                                        <div className="value text-lg">Usage: {payload[0].value + ' kWh'}</div>
                                    </div>
                                );
                            }
                            return null;
                        }}
                    />
                    <Bar dataKey="value" isAnimationActive={true} radius={0} maxBarSize={30}>
                        {data.map((entry: any, idx: any) => (
                            <Cell
                                key={idx}
                                fill="url(#gradient1)"
                            />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}
